import { wrapWithProvider } from "@resourcehub/resourcehub-components";

export const wrapRootElement = wrapWithProvider;
